/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'post': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M0 1.25C0 2.198 3.867 2.5 16 2.5s16-.302 16-1.25S28.133 0 16 0 0 .302 0 1.25m16.238 7.912c-1.575 1.575-1.596 5.08-.038 6.638.933.933.861 1.2-.326 1.2-1.708 0-5.249 3.573-6.194 6.25-.56 1.587.265 1.75 8.851 1.75C26.405 25 28 24.74 28 23.455c0-1.674-3.79-5.885-5.943-6.603-1.098-.366-1.089-.828.049-2.651 2.431-3.891-2.652-8.255-5.868-5.039m-9.969 1.531c.973.254 2.323.237 3-.037.677-.274-.119-.481-1.769-.461-1.65.02-2.204.244-1.231.498m0 8c.973.254 2.323.237 3-.037.677-.274-.119-.481-1.769-.461-1.65.02-2.204.244-1.231.498M.079 30.25C.007 31.847 1.398 32 16 32s15.993-.153 15.921-1.75c-.047-1.045-.282-1.247-.583-.5-.722 1.789-29.954 1.789-30.676 0-.301-.747-.536-.545-.583.5" _fill="currentColor" fill-rule="evenodd"/>'
  }
})
